import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const containerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  border-left: 4px solid ${theme.colors.neutral10};
  padding: ${theme.spacing(1, 2)};
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.neutral5};
  }
`;

interface GetContainerStyleConfig {
  isSelected: boolean;
}

export function getContainerStyle({ isSelected }: GetContainerStyleConfig) {
  if (!isSelected) {
    return containerStyle;
  }

  return [
    containerStyle,
    css`
      border-color: ${theme.colors.primary50};
    `,
  ];
}

export const formNameStyle = css`
  display: inline-flex;
  flex: 1;
  overflow: hidden;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
